var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ('2' === _vm.paramMapAll['USER_WITHDRAW_TEMPLATE'])?_c('m-withdraw-modal2',{ref:"currentModal"}):_c('m-withdraw-modal1',{ref:"currentModal"})}
var staticRenderFns = []

export { render, staticRenderFns }